  $(document).ready(function() {
    var block = $("#sku-block");
    if(block.length===0)return;
    $("#sku-block .product__spec").hide();
    block.prev().css({
        'margin-bottom': '0px'
    });
    var ar = block.data('sku');
    var stockObj = {};
    var currentSKU = "";
    if (ar.length == 1) {
        currentSKU = ar[0];
    }

    $.ajax({
        url: "https://phpstack-797258-4147192.cloudwaysapps.com/CheckStock/checkstock.php",
        type: "post",
        data: JSON.stringify({
            search: ar
        }),
        contentType: "application/json",
        success: function(data) {
            if (data.length == 0) {
                return;
            }
            let newData = data;
            for (var i = 0; i < newData.length; i++) {
                Object.keys(newData[i]).forEach(key => {
                    stockObj[key] = newData[i][key];
                });
            }
            if (currentSKU.length != 0) {
                handleStock();
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log("error");
        }
    });

    const pfpForms = document.querySelectorAll('.shopify-product-form');
    if (!!pfpForms) {
        pfpForms.forEach(pfpForm => {
            pfpForm.addEventListener('prodVariant:changed', event => {
                if (!!event.detail.newVariant) {
                    if (!!event.detail.newVariant.sku) {
                        currentSKU = event.detail.newVariant.sku;
                        handleStock();
                    }
                }
            });
        });
    }

    function handleStock() {
        if (!$.isEmptyObject(stockObj)) {
            if (stockObj.hasOwnProperty(currentSKU)) {
                let des = stockObj[currentSKU];
                $("#sku-block .spec__data").html(` ${des}`);
                $("#sku-block .product__spec").css("display", "flex");
                if (des == "Out of Stock") {
                    $("#sku-block .product__spec").addClass("outofstock");
                } else {
                    $("#sku-block .product__spec").removeClass("outofstock");
                }
            } else {
                $("#sku-block .product__spec").hide();
            }
        } else {
            $("#sku-block .product__spec").hide();
        }
    }
  });
